<template>
    <div
        aria-live="polite"
        aria-atomic="true"
    >
        <v-flex v-if="showTarification" xs12 class="tarification text-center">
            <div
                v-if="service && service.enablePricing && service['price']"
                class="price body-2 px-2 py-1"
            >
                {{ $t('appt.price') }} {{ formattedPrice }}
            </div>
            <div
                v-else-if="service && service.enablePricing && !service['price']"
                class="price body-2 px-2 py-1"
            >
                {{ $t('appt.feesWillApply') }}
            </div>
            <div
                v-if="service && service.enablePricing && service['priceDescription' + upperLocale]"
                class="price-description body-2"
                :class="service && service['price'] ? 'px-2 pb-2' : 'pa-2'"
            >
                {{ service['priceDescription' + upperLocale] }}
            </div>
            <div
                v-if="service && !service.enablePricing"
                class="price-description body-2"
                :class="service && service['price'] ? 'px-2 pb-2' : 'pa-2'"
            >
                {{ $t('appt.freeOfCharges') }}
            </div>
        </v-flex>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { find } from 'lodash';
import { ServiceSettings } from '@/enums';

export default {
    name: 'tarification',
    props: {
        service: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),

        formattedPrice() {
            if (this.service && this.service.price) {
                return this.service.price.toFixed(2) + '$';
            }

            return '';
        },

        isFluTarificationModeActivated() {
            if (this.service && this.service.settings) {
                const setting = find(this.service.settings, {
                    setting: ServiceSettings.FLU_TARIFICATION_MODE_VALUE,
                });
                return setting && setting.value === 'flu';
            }
            return false;
        },

        showTarification() {
            return !this.isFluTarificationModeActivated;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import './src/assets/scss/variables';
    .v-application {
        .tarification {
            background-color: $cs-color-primary;
            .body-2 {
                font-weight: 500;
                font-size: 1.1rem !important;
            }
        }
    }
</style>
